import { useTranslation } from 'react-i18next';
import { ANALYTICS_RETAIL_EVENTS } from 'pi-kiosk-shared/analyticsEvents';
import { useCustomerAnalytics } from '../../../shared/analytics/CustomerAnalyticsProvider.js';
import { toCustomerFacingErrorMessage } from '../../../shared/errors/toCustomerFacingErrorMessage.js';
import { Button } from '../../../shared/ui/Button.js';
import { useCustomerAckInformationalPickup } from '../ordersApi.js';

export interface InformationalPickupAckButtonProps {
  transactionId: number;
  version: number;
}

export function InformationalPickupAckButton({
  transactionId,
  version,
}: InformationalPickupAckButtonProps): JSX.Element {
  const { t } = useTranslation('customer');
  const analytics = useCustomerAnalytics();
  const ackMutation = useCustomerAckInformationalPickup();

  return (
    <div className="flex flex-col gap-2 rounded-md border border-[var(--color-border)] p-3">
      <p className="text-sm font-medium text-[var(--color-on-surface)]">
        {t('account.orders.informationalPickupAckTitle')}
      </p>
      <p className="text-xs text-[var(--color-on-surface-muted)]">
        {t('account.orders.informationalPickupAckHint')}
      </p>
      <Button
        type="button"
        intent="primary"
        size="md"
        block
        loading={ackMutation.isPending}
        onClick={() => {
          ackMutation.mutate(
            { transactionId, version },
            {
              onSuccess: () => {
                analytics.track({
                  eventName: ANALYTICS_RETAIL_EVENTS.CUSTOMER_PICKUP_ACK_INFORMATIONAL,
                  flow: 'RETAIL',
                  screenName: 'order_detail',
                  metadata: { transactionId },
                });
              },
            }
          );
        }}
      >
        {t('account.orders.informationalPickupAckButton')}
      </Button>
      {ackMutation.isError ? (
        <p className="text-xs text-[var(--color-danger)]">
          {toCustomerFacingErrorMessage(ackMutation.error, {
            fallback: t('errors.generic'),
          })}
        </p>
      ) : null}
    </div>
  );
}
